const VEHICLE_CAPABLE_ACTION = {
  IS_VEHICLE_CAPABLE: 'IS_VEHICLE_CAPABLE',
  VEHICLE_CAPABLE_SUCCESS: 'VEHICLE_CAPABLE_SUCCESS',
  VEHICLE_CAPABLE_ERROR: 'VEHICLE_CAPABLE_ERROR',
};

export default VEHICLE_CAPABLE_ACTION;
